<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">

			<el-form-item label="房间号">
				<el-input :disabled="true" v-model="room_num" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="充值金额" prop="money"><br>
				<el-input v-model="inputmodel.money" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		meters_top_up
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";

	export default {
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '设备编号',
					model: 'meters'
				}],
				inputmodel: {
					meters: '',
					money: '',
					device_type: ''
				},
				rules: {},
				room_num: ''
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);

				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {

							meters_top_up(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			var value = JSON.parse(JSON.stringify(this.item));
			const {
				device_no,
				device_type,
				room_num
			} = value
			this.inputmodel.meters = device_no
			this.inputmodel.device_type = device_type
			this.room_num = room_num
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);
				var value = JSON.parse(JSON.stringify(this.item));
				const {
					device_no,
					device_type,
					room_num
				} = value
				this.inputmodel.meters = device_no
				this.inputmodel.device_type = device_type
				this.room_num = room_num
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>